import React, { Component } from 'react'
import { DatePicker, Button, Select,AutoComplete,Input,message,Icon,Modal } from "antd";
import SearchRetrieve from "../../common/SearchRetrieve.new";
import API_URL from "../../../common/url";
import Fetch from "../../../common/Fetch";
import ExportUtil from '../../../common/ExportUtil';
import UploadFile from '../../common/UploadFile';
import $ from "../../../common/AjaxRequest";
import moment from "moment";

const monthFormat = "YYYY-MM";
const { MonthPicker } = DatePicker;
const { Option } = Select;

const arCodes = [
    { arCode: "已确认收入未开票" },
    { arCode: "已开票未收款" },
];
const companyNames = [
    { companyName: "上海津石" },
    { companyName: "无锡津石" },
    { companyName: "北京津石" },
];
const accountDistributes =[
    { accountDistribute: "forFuture",accountDistributeShow:'信用期内' },
    { accountDistribute: "less31",accountDistributeShow:'31天内' },
    { accountDistribute: "day31To60",accountDistributeShow:'31~60天' },
    { accountDistribute: "day61To90",accountDistributeShow:'61~90天' },
    { accountDistribute: "day91To120",accountDistributeShow:'91~120天' },
    { accountDistribute: "day121To150",accountDistributeShow:'121~150天' },
    { accountDistribute: "day151To180",accountDistributeShow:'151~180天' },
    { accountDistribute: "day181To3650",accountDistributeShow:'181~365天' },
    { accountDistribute: "day366To730",accountDistributeShow:'366~730天' },
    { accountDistribute: "day731To1095",accountDistributeShow:'731~1095天' },
    { accountDistribute: "great1095",accountDistributeShow:'1095天以上' },
    { accountDistribute: "sumGreat120",accountDistributeShow:'120天以上合计' },
    { accountDistribute: "sumGreat365",accountDistributeShow:'365天以上合计' },
]
const code13Descs =[
    {code13:"SMO-临床肿瘤"},
    {code13:"SMO-临床非肿瘤"},
    {code13:"SMO-临床综合"},
    {code13:"SMO-医院发展部"},
    {code13:"SMO-医学和数据"},
    {code13:"SMO-临床部 (禁用)"},
];

export default class Filter extends Component {
    state = {
        maxDate: moment(),
        saveParams: {},
        visible:false,
        startMonth:null,
        visibleUpload:false,
        uploadMes:{
            successNum:0,
            failNum:0,
            errorNum:0
        }
    };

    componentDidMount(){
        this.quertDisabledDate()
    }

    search = () => {
        const { saveParams } = this.state;
        this.props.search(saveParams);
    };
    
    quertDisabledDate = () =>{
        Fetch.post(API_URL.dashboard.queryRecordYearMonth)
            .then((res) => {
                const { max, min } = res;
                this.setState({
                    maxDate:max,
                    minDate:min
                })
            })
            .catch((err) => {
                console.error(err);
        });
    }

    disabledDate = (current) => {
        const { maxDate, minDate } = this.state;
        const maxValue = moment(maxDate).add(1 , 'M').valueOf();
        const minValue = moment(minDate).valueOf();
        return !(current && current.valueOf() >= minValue && current.valueOf() <= maxValue);
        
    };

    handleFilterChange = (saveParams) => {
        this.setState({ saveParams: {...saveParams} });
    }

    handleChange = (value, key) => {
        const { saveParams } = this.state;
        switch (key) {
            case 'customerCompanyName': {
                const name = value.text;
                saveParams[`customerName`] = name;
                this.handleFilterChange(saveParams);
                break;
            }
            case 'customerCompanyCode': {
                saveParams[`customerCode`] = value;
                this.handleFilterChange(saveParams);
                break;
            }
            case 'companyNames':
            case 'accountDistribute':
            case 'code13Descs':
                saveParams[key] = value ? value.join(',') : undefined;
                this.handleFilterChange(saveParams);
                break;
            default:
                saveParams[key] = value;
                this.handleFilterChange(saveParams);
                break;
        }
        this.setState({ saveParams });
    };

    downTemplate = () => {
        ExportUtil.export({}, null, API_URL.dashboard.getAccountsReceivableImport);
        message.success('正在下载中!')
    }

    exportReport = () =>{
        const { saveParams } = this.state;
        Fetch.post(API_URL.dashboard.exportAccountsReceivableList, {
            ...saveParams,
        })
            .then((res) => {
                message.success(res.success)
            })
            .catch((err) => {
                console.error(err);
            });
    }
    
    exportCuringReport = () =>{
        const { saveParams , startMonth} = this.state;
        Fetch.post(API_URL.dashboard.exportAccountsReceivableList, {
            ...saveParams,
            date:startMonth
        })
            .then((res) => {
                message.success(res.success)
                this.setState({visible:false})
            })
            .catch((err) => {
                console.error(err);
                this.setState({visible:false})
            });
    }

    queryTaskStatus = () => {
        const options = {
            method: 'POST',
            url: API_URL.dashboard.accountsReceivableSync,
            data: {},
            dataType: 'json',
            doneResult: res => {
                // const { data } = res;
                // const { status } = data || {};
                // if (status === 'COMPLETED') {
                //     Modal.success({ title: '数据统计任务成功' });
                // } else {
                //     Modal.warning({ title: '刷新统计任务正在进行中，请稍后再试！' });
                // }
                console.log(res);
            }
        }
        $.sendRequest(options);
    }
    
    onMonthChange = (date, dateString) => {
        this.setState({ startMonth:dateString });
    }

    onUplodChange = (file,fileList)=> {
        if (file.status == "done") {
            if (file.response.error) {  
                message.error(file.response.error);
                file.status = 'removed';
            } else {
                const {uploadMes} = this.state;
                uploadMes.errorNum=file.response.errorNum;
                uploadMes.successNum=file.response.successNum;
                uploadMes.failNum=file.response.failNum;
                this.setState({uploadMes,visibleUpload:true})
            }
        }
    }

    downErrorReport = (params)=>{
        ExportUtil.export(params, null, API_URL.dashboard.getImportFailList);
        message.success('正在下载中!')
    }

    render() {
        const { saveParams ,visible,startMonth ,visibleUpload,uploadMes} = this.state;
        const arCodeOption = arCodes.map(d => <Option key={d.arCode}>{d.arCode}</Option>);
        const companyNameOption = companyNames.map(d => <Option key={d.companyName}>{d.companyName}</Option>);
        const accountDistributeOption = accountDistributes.map(d => <Option key={d.accountDistribute}>{d.accountDistributeShow}</Option>);
        const code13Option = code13Descs.map(d => <Option key={d.code13}>{d.code13}</Option>);
        return (
            <div>
                <div className="search-bar">
                <div className="search-item">
                    <label className="ui-label">AR分类</label>
                    <Select
                        placeholder="请选择"
                        style={{ width: 120 }}
                        value={saveParams.arCodeShow }
                        allowClear={true}
                        onChange={(value) => this.handleChange(value, "arCodeShow")}
                    >
                        {arCodeOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label className="ui-label">公司名称</label>
                    <Select
                            mode="multiple"
                            allowClear={true}
                            filterOption={false}
                            placeholder="请选择"
                            style={{width: 120}}
                            className="multiple-stage"
                            onChange={value => this.handleChange(value, 'companyNames')}
                        >
                            {companyNameOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">客户名称</label>
                    <SearchRetrieve
                        keyword='customerCompanyName'
                        style={{ width: 140 }}
                        placeholder="请选择"
                        value={saveParams.customerName}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryCustomerCompanyByName}
                        config={{id: 'customerCompanyId', name: 'customerCompanyName'}}
                        onChange={value => this.handleChange(value, 'customerCompanyName')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">客户JDE号</label>
                    {/* <SearchRetrieve
                        keyword='customerCompanyCode'
                        style={{ width: 80 }}
                        placeholder="请选择"
                        value={saveParams.customerCode}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryCustomerCompanyByName}
                        config={{id: 'customerCompanyCode', name: 'customerCompanyCode'}}
                        onChange={value => this.handleChange(value, 'customerCompanyCode')}
                    /> */}
                    <Input
                        placeholder="请输入"
                        style={{ width: 120 }}
                        value={saveParams.customerCode}
                        // onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleChange(e.target.value, 'customerCompanyCode')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">账期分布</label>
                    <Select
                            mode="multiple"
                            allowClear={true}
                            filterOption={false}
                            placeholder="请选择"
                            style={{width: 150}}
                            className="multiple-stage"
                            onChange={value => this.handleChange(value, 'accountDistribute')}
                        >
                            {accountDistributeOption}
                        </Select>
                </div>
                <div className="search-item">
                    <div className="ui-label">JDE主项目号</div>
                    <Input
                        placeholder="请输入"
                        style={{ width: 120 }}
                        value={saveParams.queryMainJdeCode}
                        // onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleChange(e.target.value, 'queryMainJdeCode')}
                    />
                </div>
                <div className="search-item">
                    <div className="ui-label">JDE项目号</div>
                    <Input
                        placeholder="请输入"
                        style={{ width: 120 }}
                        value={saveParams.sectionNCode}
                        // onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleChange(e.target.value, 'sectionNCode')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">类别码13描述</label>
                    <Select
                            mode="multiple"
                            allowClear={true}
                            filterOption={false}
                            placeholder="请选择"
                            style={{width: 120}}
                            className="multiple-stage"
                            onChange={value => this.handleChange(value, 'code13Descs')}
                        >
                            {code13Option}
                        </Select>
                </div>
                <div className="search-item">
                        <label htmlFor="" className="ui-label">应收账款是否大于0</label>
                        <Select
                            allowClear={true}
                            style={{ width: 80 }}
                            placeholder="请选择"
                            value={saveParams.accountsGreatZero}
                            onChange={value => this.handleChange(value, 'accountsGreatZero')}
                        >
                            <Option key={'1'}>是</Option>
                            <Option key={'0'}>否</Option>
                            <Option key={'-1'}>-</Option>
                        </Select>
                    </div>
                {/* <div>
                    <label className="ui-label">业务线</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        className="multiple-stage"
                        value={saveParams.lineOfBusiness}
                        onChange={value => this.handleChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                    </Select>
                </div> */}
            
                
            </div>
            <div className="search-bar flex-end" >
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.exportReport}>导出</Button>
                        <Button type="primary" onClick={this.downTemplate}>下载模板</Button>
                        <UploadFile
                            uploadUrl={API_URL.dashboard.importARUc}
                            showUploadList={false}
                            onChange={this.onUplodChange}
                        >
                            <Button type="primary">导入数据</Button>
                        </UploadFile>
                        <Button type="primary" onClick={()=>{this.setState({visible:true})}} 
                        style={{backgroundColor:'#ffcc00',borderColor:'#f93'}}>导出固化数据</Button>
                        <Modal 
                            title="导出固化数据"
                            visible={visible}
                            onCancel={()=>{this.setState({visible:false})}}
                            onOk={this.exportCuringReport}
                            width={400}>
                                <div style={{textAlign:'center'}}>
                                    <label className="ui-label" style={{marginRight:'5px'}}>请选择固化月份</label>
                                        <MonthPicker
                                            format={monthFormat}
                                            allowClear={true}
                                            placeholder="选择月份"
                                            disabledDate={this.disabledDate}
                                            onChange={(date, dateString) => this.onMonthChange(date, dateString)}
                                        />
                                </div>
                        </Modal>
                        <Modal 
                            visible={visibleUpload}
                            width={300}
                            footer={null}
                            >
                            <div style={{padding:'0 10px'}}>
                                <div style={{fontSize:'14px',fontWeight:'700',padding:'10px 0'}}>本次导入的AR aging数据:</div>
                                <p>导入成功{uploadMes.successNum}条</p>
                                <p>导入失败{uploadMes.failNum}条</p>
                                <p>数据错误{uploadMes.errorNum}条</p>
                                <div style={{textAlign:'right',marginTop:'20px'}}>
                                    <Button size='large' style={{margin:'0 5px',fontSize:'12px'}} 
                                    onClick={()=>{this.setState({visibleUpload:false})}}>关闭</Button>
                                    <Button type="primary" size='large' style={{margin:'0 5px',backgroundColor:'#169bd5',fontSize:'12px',borderColor:'#169bd5'}} onClick={this.downErrorReport}>下载错误报告</Button>
                                </div>
                            </div>
                        </Modal>
                    </div>
                </div>
            </div>
            
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/financeManagement/collectReport/Filter.js